import { defineStore } from 'pinia';
import { TNormalizedVisibilityLevel } from 'types';
import * as api from 'src/services/visibility-levels';
import { useAsyncAction } from 'src/composables/shared/useAsyncAction';
import { ref } from 'vue';
import { readCache, writeCache } from 'src/utils/cache';

const CACHE_KEY = 'visibility-levels';

export const useVisibilityLevelsStore = defineStore('visibility-levels', () => {
  const visibilityLevels = ref<TNormalizedVisibilityLevel[]>([]);
  const error = ref<string | null>(null);
  const { run, loading } = useAsyncAction();

  function getVisibilityLevels() {
    if (loading.value) {
      return;
    }

    error.value = null;

    const cached = readCache<TNormalizedVisibilityLevel[]>(CACHE_KEY);
    if (cached) {
      visibilityLevels.value = cached;
    }
    return run(
      async () => {
        const levels = await api.fetchVisibilityLevels();
        visibilityLevels.value = levels;
        writeCache(CACHE_KEY, levels);
      },
      () => {
        error.value = 'Failed to load visibility levels';
      },
    );
  }

  // Fetch immediately on store initialization
  getVisibilityLevels();

  return {
    visibilityLevels,
    getVisibilityLevels,
    error,
    loading,
  };
});
